import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Tabs, Events } from 'ionic-angular';
import { PedidosPage } from '../pedidos/pedidos';
import { ClientesPage } from '../clientes/clientes';
import { DashboardPage } from '../dashboard/dashboard';
import { HomePage } from '../home/home';
import { VendedoresPage } from '../vendedores/vendedores';

/**
 * Generated class for the TabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {
  tab1Root = DashboardPage;
  tab2Root = ClientesPage;
  tab3Root = PedidosPage;
  tab4Root = HomePage;
  tab5Root = VendedoresPage;
  @ViewChild('myTabs') tabRef: Tabs;
  super: any = true
  loading: any = true
  constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events) {
  }

  ionViewDidLoad() {
    if (this.navParams.get('value') === "Dashboard") {
      this.tabRef.select(0)
    } else if (this.navParams.get('value') === "Clientes") {
      this.tabRef.select(1)
    } else if (this.navParams.get('value') === "Pedidos") {
      this.tabRef.select(3)
    } else if (this.navParams.get('value') === "Articulos") {
      this.tabRef.select(4)
    } else if (this.navParams.get('value') === "Vendedores") {
      this.tabRef.select(2)
    }
  }

  onTabsChange() {
    // Get the previous tab if any
    const previousTab = this.tabRef.previousTab(false);

    if(previousTab) {
      try {
        // Get the navCtrl and pop to the root page
        previousTab.getViews()[0].getNav().popToRoot();
      } catch(exception) {
        // Oops...
        console.error(exception);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts